export default __webpack_public_path__ + "static/media/image 119.89404b5a.png";